// includes/UserHelper.js
const getUser = () => {
    const userData = localStorage.getItem("user");
    return userData ? JSON.parse(userData) : null;
  };
  
  export default getUser;
  